export const CEAF = 'C​E​A​F';
export const SIA = 'S​I​A';
